import { useMediaQuery, useTheme } from '@mui/material';
import {
  getMetricFontSizes,
  METRIC_FONT_SIZES,
  type ResponsiveFontSizes,
} from '../constants';

interface UseResponsiveFontSizeReturn {
  responsiveFontSizes: ResponsiveFontSizes;
  currentFontSize: number;
}

export const useResponsiveFontSize = (
  compact: boolean,
): UseResponsiveFontSizeReturn => {
  const theme = useTheme();

  const fontSizes = getMetricFontSizes(theme.typography.pxToRem);
  const responsiveFontSizes = compact ? fontSizes.compact : fontSizes.normal;

  // Derive currentFontSize from METRIC_FONT_SIZES to match responsiveFontSizes breakpoint behavior
  // Use up('md') to match when font size switches to desktop value (48px for normal, 18px for compact)
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const sizeConfig = compact
    ? METRIC_FONT_SIZES.compact
    : METRIC_FONT_SIZES.normal;

  // For AnimatedCurrency, we need the pixel value, not rem
  // Match the breakpoint logic: md and above use desktop size, below md uses mobile size
  const currentFontSize = isDesktop
    ? (sizeConfig.md as number)
    : (sizeConfig.xs as number);

  return {
    responsiveFontSizes,
    currentFontSize,
  };
};
